import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { DeriveSharedSecret$ } from "../schemas/schemas_0";
export { $Command };
export class DeriveSharedSecretCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "DeriveSharedSecret", {})
    .n("KMSClient", "DeriveSharedSecretCommand")
    .sc(DeriveSharedSecret$)
    .build() {
}
